<template>
  <v-dialog v-model="openMode" max-width="500px">
    <v-card class="edit-dialog">
      <v-card-title class="dialog-header">
        <v-icon left class="ml-2" dark>mdi-phone-settings</v-icon>
        ערוך מספר {{ itemEdited.line_number }}
      </v-card-title>

      <v-card-text>
        <v-container class="edit-container">
          <v-card outlined class="settings-card">
            <v-card-title class="settings-title">
              <v-icon color="#0d2c6d" class="ml-2">mdi-cog</v-icon>
              הגדרות מספר
            </v-card-title>
            <v-card-text>
              <v-form @submit.prevent="submitHandler" ref="form">
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-select :items="types" v-model="itemEdited.type" outlined dense label="סוג"
                      class="input-field"></v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="itemEdited.belong_to_agent" outlined dense type="number" hide-spin-buttons
                      label="שייך לסוכן" class="input-field"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6">
                    <v-autocomplete :items="coutryCodes" v-model="itemEdited.callerid_country_codes" item-text="he"
                      item-value="en" outlined dense multiple chips small-chips label="בחר מדינות לשיחות יוצאות"
                      :rules="[v => !!v || 'שדה חובה']" required class="input-field"></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field v-model="itemEdited.user_active" outlined dense type="number" inputmode="numeric"
                      hide-spin-buttons label="מחובר למערכת מספר" class="input-field" :rules="[
                        v => !v || /^\d+$/.test(v) || 'יש להזין ספרות בלבד', v => !v || !/[eE+-]/.test(String(v)) || 'יש להזין ספרות בלבד',
                        v => !v || String(v).length >= 4 || 'יש להזין לפחות 4 ספרות', v => !v || String(v).length < 15 || 'מספר קו לא תקין'
                      ]"></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="dialog-actions">
        <v-btn color="primary" class="save-button" @click="updateNumber()" :loading="progressShow"
          :disabled="progressShow">
          <v-icon left>mdi-content-save</v-icon>
          שמור שינויים
        </v-btn>
        <v-btn color="grey lighten-3" @click="closeDelete">
          סגור
        </v-btn>
      </v-card-actions>
    </v-card>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import sharedFunctions from '@/shared/sharedFunctions';

export default {
  props: {
    value: { type: Boolean, default: false },
    editNumber: { type: Object },
  },
  components: {
    SnackBar,
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    itemEdited: {},
    types: ["מספר כללי", "פתיחת מערכת"],
    coutryCodes: [],
  }),

  methods: {
    async updateNumber() {
      try {
        if (this.$refs.form.validate()) {

          this.progressShow = true;
          let token = localStorage.getItem("token");
          const itemsJSON = JSON.stringify({ number: this.itemEdited });

          let api = process.env.VUE_APP_BASE_URL + "/admin_api/edit_number_agent";
          const res = await fetch(api, ApiServices.requestOptions("POST", itemsJSON, token));
          const jsonObject = await res.json();
          this.progressShow = false;
          if (res.status >= 400) {
            this.showSnackBar("שגיאה בשמירת השינויים: " + jsonObject, "red");
          } else if (res.status === 200) {
            this.$emit("numberAgentChange", this.itemEdited, "השינויים בוצעו בהצלחה", "green");
            this.closeDelete();
          }
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("שגיאה בשמירת שינויים : " + error, "red");
      }
    },
    closeDelete() {
      this.openMode = false;
    },
    async getCountryCodes() {
      this.coutryCodes = await sharedFunctions.getCountryCodes();
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },
  },
  computed: {
    openMode: {
      get() {
        return this.value;
      },
      set(v) {
        return this.$emit('input', v);
      }
    },
  },
  mounted() {
    this.getCountryCodes();
    this.itemEdited = { ...this.editNumber };
  },
}
</script>

<style scoped>
.edit-dialog {
  border-radius: 12px;
  overflow: hidden;
  direction: rtl;
  font-family: 'Heebo', sans-serif;
}

.dialog-header {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.edit-container {
  padding: 16px 0;
}

.settings-card {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.settings-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.settings-title {
  font-size: 16px;
  font-weight: 600;
  color: #0d2c6d;
  padding: 12px 16px;
  margin-bottom: 12px;
  background-color: rgba(13, 44, 109, 0.05);
}

.input-field {
  border-radius: 8px;
}

.dialog-actions {
  padding: 16px;
  display: flex;
  justify-content: flex-start;
}

.save-button {
  background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%) !important;
  color: #0d2c6d !important;
  font-weight: 600;
  margin-left: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.save-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .dialog-actions {
    flex-direction: column;
  }

  .save-button {
    margin-left: 0;
    margin-bottom: 8px;
    width: 100%;
  }
}
</style>